import { httpsCallable } from "firebase/functions";
import { cloudFunctions } from "./getFunctions";
import {
  InvitacionAceptar,
  CloudFunctionResponse,
  CallablesGeneral
} from "@fixeduy/restaurantestypes";

const invitacionAceptar = async (
  data: InvitacionAceptar
): Promise<CloudFunctionResponse> => {
  const run = httpsCallable<CallablesGeneral, CloudFunctionResponse>(
    cloudFunctions,
    "callablesGenerales"
  );
  const result = await run({
    func: "invitacionAceptar",
    params: data
  });
  return result.data;
};

export { invitacionAceptar };
